import React, {Component} from 'react';
import {
    withStyles,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Grid,
    Checkbox,
    FormControlLabel,
} from 'material-ui';
import styles from './style/styles';

class PageTranslateDialog extends Component {
    render() {
        const {
            handleSubmit,
            handleRequestClose,
            open,
            classes,
            pageTitle,
            pageSiteName,
            updateAddTranslationSites,
            missingPageTranslations,
            handleSelectAll,
        } = this.props;

        return (
            <Dialog
                open={open}
                onClose={handleRequestClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    {'Add translation clone(s) from ' +
                        pageSiteName +
                        ' for Page: "' +
                        pageTitle +
                        '"'}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            <Typography variant="body2">
                                Select below the websites you want to create
                                page translation clone(s) for:
                            </Typography>
                        </Grid>

                        <Grid container spacing={0} id="select-field">
                            <Grid item xs={12}>
                                {missingPageTranslations.map((option) => (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={option.is_checked}
                                                value={option.id.toString()}
                                                key={option.id}
                                                disabled={
                                                    !!option.has_translation
                                                }
                                                onChange={(event) => {
                                                    updateAddTranslationSites(
                                                        event.target.value
                                                    );
                                                }}
                                            />
                                        }
                                        label={option.name}
                                        key={option.id}
                                        disabled={!!option.has_translation}
                                    />
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.cloneActionsBtns}>
                    <Button
                        onClick={handleSelectAll}
                        variant="raised"
                        color="primary"
                        className={classes.cloneActionsBtn}
                    >
                        Select All
                    </Button>
                </DialogActions>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button onClick={handleRequestClose} variant="raised">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="raised"
                        color="primary"
                        type="submit"
                        disabled={false}
                    >
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(PageTranslateDialog);



// WEBPACK FOOTER //
// ./src/containers/pages/PageTranslateDialog.jsx